import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierStatus extends Layout {
    sourceCarrierStatus: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
